import React from 'react';
import { X, Calendar, User } from 'lucide-react';

type HistoryDetailsModalProps = {
  onClose: () => void;
  data: {
    id_log: number;
    name: string;
    email: string;
    created_at: string;
    data: {
      table: {
        approved: {
          rows: any[][];
          config: {
            columns: {
              key: string;
              label: string;
              locked: boolean;
              format?: string;
            }[];
          };
        };
        billed: {
          rows: any[][];
          config: {
            columns: {
              key: string;
              label: string;
              locked: boolean;
              format?: string;
            }[];
          };
        };
      };
      changes: {
        approved: {
          rows: any[][];
          config: {
            columns: {
              key: string;
              label: string;
              locked: boolean;
              format?: string;
            }[];
          };
        };
        billed: {
          rows: any[][];
          config: {
            columns: {
              key: string;
              label: string;
              locked: boolean;
              format?: string;
            }[];
          };
        };
        selectedYear: string;
      };
    };
  };
};

export const HistoryDetailsModal = ({ onClose, data }: HistoryDetailsModalProps) => {
  console.log(data);

  const renderTable = (type: 'approved' | 'billed') => {
    const tableData = data.data.table[type];
    const changesData = data.data.changes[type];
    const columns = tableData.config.columns;

    return (
      <div>
        <div
          className={`bg-gradient-to-r ${
            type === 'approved' ? 'from-green-600 to-green-700' : 'from-blue-600 to-blue-700'
          } text-white px-6 py-3 rounded-t-xl`}
        >
          <h2 className="text-lg font-semibold text-white">
            {type === 'approved' ? 'APROVADO' : 'FATURADO'}
          </h2>
        </div>
        <div className="bg-white rounded-b-xl shadow-sm border-x border-b border-gray-200 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {columns.map((col, index) => (
                  <th
                    key={index}
                    className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap"
                  >
                    {col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {tableData.rows.map((row, rowIndex) => (
                <tr key={rowIndex} className="hover:bg-gray-50">
                  {row.map((cell, colIndex) => {
                    // Recupera o valor novo a partir dos dados de alteração
                    const changedValue = changesData?.rows?.[rowIndex]?.[colIndex];
                    const hasChanged =
                      changedValue !== undefined && cell !== changedValue;

                    return (
                      <td
                        key={colIndex}
                        title={
                          hasChanged
                            ? `Alterado de "${cell || '-'}" para "${changedValue || '-'}"`
                            : ''
                        }
                        className={`px-6 py-4 whitespace-nowrap text-sm ${
                          hasChanged ? 'bg-yellow-50 border-b border-yellow-100' : ''
                        }`}
                      >
                        {hasChanged ? (
                          <div className="flex flex-col gap-1">
                            <span className="text-green-600 line-through">
                              {cell || '-'}
                            </span>
                            <span className="text-red-600 font-medium line-through">
                              {changedValue || '-'}
                            </span>
                          </div>
                        ) : (
                          <span className="text-gray-900">{cell || '-'}</span>
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="bg-white rounded-2xl shadow-xl overflow-hidden max-h-[90vh] flex flex-col">
      {/* Header */}
      <div className="px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white/10 rounded-lg">
            <Calendar className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-white">
              Detalhes da Alteração
            </h3>
            <div className="flex items-center gap-2 mt-1 text-white/80">
              <User className="w-4 h-4" />
              <span className="text-sm">{data.name}</span>
              <span className="text-sm">•</span>
              <span className="text-sm">{data.email}</span>
              <span className="text-sm">•</span>
              <span className="text-sm">
                {new Date(data.created_at).toLocaleString()}
              </span>
            </div>
          </div>
        </div>
        <button
          onClick={onClose}
          className="p-2 text-white/80 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
        >
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Content */}
      <div className="p-6 overflow-y-auto space-y-8">
        {renderTable('approved')}
        {renderTable('billed')}
      </div>
    </div>
  );
};
